import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import ImageGridScroll from '../components/ImageGridScroll.js';
import { useSEO } from '../components/CustomHook';
import Gundlach from '../images/testimonial/Gundlach.jpg';
import Heilig from '../images/testimonial/Heilig.jpg';
import Kanamuller from '../images/testimonial/Kanamüller.jpg';
import Nittel from '../images/testimonial/Nittel.jpeg';
import Schlegel from '../images/testimonial/Schlegel.jpeg';

const Testimonials = () => {
    useSEO(
        "Kundenrezensionen - Bewertungen unserer Photovoltaik-Kunden | Schmid Energieberatung",
        "Lesen Sie echte Kundenbewertungen und Erfahrungsberichte unserer Photovoltaik-Kunden. Erfahren Sie, warum Kunden Schmid Energieberatung vertrauen.",
        "Kundenrezensionen, Bewertungen, Photovoltaik Erfahrungen, Solar Kunden, Schmid Energieberatung Bewertungen",
        "/images/testimonials-banner.webp"
    );

    const testimonials = [
        {
            location: "Pforzheim, Baden-Württemberg",
            customer: "Familie Heilig",
            text:
            <>
            Wir sind mit der Zusammenarbeit rundum zufrieden! Die Dachsanierung hat sich im Vorfeld aufgrund von
            Abstimmungen mit der Denkmalbehörde um über ein Jahr verzögert, was den gesamten Ablauf erschwert hat.
            Gerade in dieser Zeit war die Kommunikation mit dir besonders wertvoll – zuverlässig, klar
            und jederzeit erreichbar. Während das Gewerk der Dachdecker teilweise sehr schwierig war,
            konnten wir uns auf dich immer verlassen.
            <br />
            <br />
            Als Einzelunternehmer hast du extrem flexibel reagiert und dafür gesorgt,
            dass trotz der Umstände alles Hand in Hand lief. Besonders schätzen wir auch,
            dass du mit regionalen Handwerkern und Lieferanten zusammenarbeitest – das schafft Vertrauen und kurze Wege.
            Mit einer großen Solarfirma hätte das niemals so reibungslos funktioniert. Danke für den hervorragenden Service!
            </>,
            systemSize: "8,3 kWp",
            systemType: "Photovoltaikanlage",
            installationTime: "9 Wo.",
            installationText: "bis zur Montage",
            image: Heilig
        },
        {
            location: "Pforzheim, Baden-Württemberg",
            customer: "Familie Nittel",
            text:
            <>
            Durch Zufall waren wir bei der Eröffnung von Schmid Energieberatung GmbH. Da wir eine Gasheizung hatten,
            überlegten wir, eine Wärmepumpe einbauen zu lassen. Im Showroom erhielten wir erste Infos zu den angebotenen
            Systemen, was uns neugierig machte. Kurz darauf folgte die Beratung vor Ort. Nachdem Herr Schmid die
            technischen Daten aufgenommen hatte, erhielten wir ein Angebot, bei dem er Alternativen aufzeigte und
            begründete, warum sein Vorschlag am besten passt. Dennoch konnten wir frei wählen.
            <br />
            <br />
            Die Beratung war stets pragmatisch und auf den wirtschaftlich größten Nutzen für uns ausgelegt.
            Der Kontakt war freundlich, die Abstimmung mit den Gewerken lief reibungslos, und wir wurden regelmäßig
            informiert. Auch die Förderanträge übernahm Herr Schmid.
            <br />
            <br />
            Insgesamt bietet die Firma Schmid Energieberatung GmbH ein sehr gutes Paket aus Beratung,
            Begleitung und technischen Lösungen. Ob sich die Investition rechnet, muss jeder selbst entscheiden
            – wir sind jedenfalls froh, diesen Schritt gegangen zu sein.
            </>,
            systemSize: "12 kWp",
            systemType: "Photovoltaikanlage",
            installationTime: "8 Wo.",
            installationText: "bis zur Montage",
            image: Nittel
        },
        {
            location: "Stuttgart, Baden-Württemberg",
            customer: "Familie Kanamüller",
            text:
            <>
            Sehr gute Beratung und unkomplizierte Umsetzung! PV Anlage war nach Kauf innerhalb von 4 Wochen auf
            dem Dach. Fühlten uns sehr gut aufgehoben. Wir haben uns für ein komplett Paket inkl. Speicher und
            Gateway von Sigenergy entschieden. Würden ihn immer weiterempfehlen.
            </>,
            systemSize: "12,88 kWp",
            systemType: "Photovoltaikanlage",
            installationTime: "4 Wo.",
            installationText: "bis zur Montage",
            image: Kanamuller
        },
        {
            location: "Eisingen, Baden-Württemberg",
            customer: "Familie Schlegel",
            text:
            <>
            Perfekte Beratung, super freundlich<br />
            Ich kann Herr Schmid nur weiterempfehlen!
            Er ist super sympathisch, fachlich top und hat uns von A bis Z perfekt beraten.
            Besonders gut gefallen hat mir, dass er unsere individuellen Bedürfnisse berücksichtigt
            hat und nicht einfach eine Standardlösung verkaufen wollte. Danke für die tolle Beratung!
            </>,
            systemSize: "9,3 kWp",
            systemType: "Photovoltaikanlage",
            installationTime: "6 Wo.",
            installationText: "bis zur Montage",
            image: Schlegel
        },
        {
            location: "Keltern, Baden-Württemberg",
            customer: "Familie Gundlach",
            text:
            <>
            Von der Beratung bis zur Installation der PV-Anlage hat alles reibungslos funktioniert.
            Sehr freundliches und professionelles Team, das alle Fragen verständlich
            beantwortet hat. Die Anlage läuft einwandfrei und ich bin begeistert von der Ersparnis.
            Absolut empfehlenswert!
            </>,
            systemSize: "10 kWp",
            systemType: "Photovoltaikanlage",
            installationTime: "8 Wo.",
            installationText: "bis zur Montage",
            image: Gundlach
        }
    ];

    return (
        <>
            <Navbar />

            {/* Hero Section */}
            <section className="py-32 px-4 sm:px-6 lg:px-8 bg-tertiary text-white">
                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                        Kundenrezensionen
                    </h1>
                    <p className="text-2xl text-white max-w-3xl mx-auto">
                        Echte Erfahrungsberichte unserer zufriedenen Kunden !
                    </p>
                </div>
            </section>

            {/* Testimonials Section */}
            <div className="bg-tertiary min-h-screen py-8">
                <div className="container mx-auto px-4">
                    <div className="max-w-8xl mx-auto space-y-32">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-16`}>
                                {/* Text Content */}
                                <div className="flex-1 text-white">
                                    {/* Location */}
                                    <div className="text-primary-light font-semibold text-xl mb-4">
                                        {testimonial.location}
                                    </div>

                                    {/* Customer Name */}
                                    <h3 className="text-3xl md:text-5xl font-bold text-white mb-8">
                                        {testimonial.customer}
                                    </h3>

                                    {/* Testimonial Text */}
                                    <p className="text-secondary-light text-xl leading-relaxed mb-12">
                                        {testimonial.text}
                                    </p>

                                    {/* Data Section */}
                                    <div className="flex justify-between items-end">
                                        <div className="text-center">
                                            <div className="text-4xl md:text-5xl font-bold text-primary-light">
                                                {testimonial.systemSize}
                                            </div>
                                            <div className="text-secondary-light text-lg">
                                                {testimonial.systemType}
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <div className="text-4xl md:text-5xl font-bold text-white">
                                                {testimonial.installationTime}
                                            </div>
                                            <div className="text-secondary-light text-lg">
                                                {testimonial.installationText}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* House Image */}
                                <div className="flex-1">
                                    <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                                        <img
                                            src={testimonial.image}
                                            alt={`Haus ${testimonial.customer}`}
                                            className="w-full h-full object-cover"
                                            onError={(e) => {
                                                e.target.src = '/images/testimonials/placeholder-house.webp';
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ImageGridScroll />

            {/* Call to Action Section */}
            <div className="bg-tertiary py-32">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
                        Werden Sie Teil unserer Erfolgsgeschichten
                    </h2>
                    <p className="text-2xl text-secondary-light mb-12 max-w-3xl mx-auto">
                        Lassen Sie sich von unseren Experten beraten und starten Sie Ihre eigene Energiewende
                    </p>
                    <div className="flex justify-center">
                        <a
                            href="/kontakt"
                            className="bg-primary text-white px-12 py-6 rounded-xl font-semibold text-xl hover:bg-primary-dark transition-colors"
                        >
                            Jetzt beraten lassen
                        </a>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Testimonials;